/* Section: product_reviews — the write-a-review panel.

   The panel is a plain disclosure: the button in the summary card owns
   aria-expanded, the panel owns an .is-open class. Everything else about the
   form is the browser's — native validation, native submit, a real page POST
   through Shopify's contact form.

   A submitted form comes back rendering either a confirmation or an error
   list, and the stylesheet opens the panel on sight of those with :has() — so
   the result is visible with JS blocked. All this does then is bring
   aria-expanded into line with what is already on screen. */
(function () {
  'use strict';

  function initSection(section) {
    var toggle = section.querySelector('[data-review-form-toggle]');
    var panel = section.querySelector('[data-review-form]');
    if (!toggle || !panel) return;
    if (panel.dataset.reviewFormReady === 'true') return;
    panel.dataset.reviewFormReady = 'true';

    function setOpen(open) {
      panel.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');

      if (!open) return;

      /* Focus the first control rather than the panel: the reader asked for
         the form, so put them in it. preventScroll because the browser's own
         scroll-into-view would jump past the heading that explains it. */
      var first = panel.querySelector('input, textarea, select, button');
      if (first) first.focus({ preventScroll: true });
    }

    /* Already open from a POST (see the file header) — say so, and leave the
       focus where the reader's own scroll position put it. */
    if (panel.querySelector('.review-form__success, .review-form__errors')) {
      panel.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }

    toggle.addEventListener('click', function () {
      setOpen(!panel.classList.contains('is-open'));
    });

    section.querySelectorAll('[data-review-form-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        setOpen(false);
        toggle.focus();
      });
    });

    /* Escape closes it, the way the header's menus do — but only while focus
       is inside, so it cannot swallow the key from anything else on the page. */
    panel.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      setOpen(false);
      toggle.focus();
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.product-reviews').forEach(initSection);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
